import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private _router: Router) { }

  canActivate(): boolean {
    var loggedIn = this.authService.loggedIn();

    if (!loggedIn) {
      //this._router.navigate([''])
      this.authService.logOut();
    } 
    
    return loggedIn
  }

  //https://codinglatte.com/posts/angular/role-based-authorization-in-angular-route-guards/
  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const requiredRoles = next.data.roles as string[];
    const loggedIn = this.authService.loggedIn();
    const currentUserRoles = this.authService.getRoles();

    if (!loggedIn) {
      //this._router.navigate([''])
      this.authService.logOut();
      return false;
    }

    if(requiredRoles && requiredRoles.length > 0){
      //https://stackoverflow.com/a/57026309/4133449
      let canActivate = currentUserRoles.some( r => requiredRoles.includes(r.RoleSystemDescription) );

      if(!canActivate){
        //this._router.navigate([''])
        this.authService.logOut();
      }

      return canActivate;
    }
    else{
      return true;
    }
  }


}
